package com.parmartechnologies.core.feature.businessConfig.network

import com.parmartechnologies.core.feature.currency.model.Currency
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class FindBusinessConfigRequest(
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("business_id") val BusinessID: String,
)

@Serializable
data class FetchBusinessConfigRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String
)


@Serializable
data class CreateBusinessConfigRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("name") val name: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("email_id") val email: String,
    @SerialName("bar_code") val Barcode: String,
    @SerialName("device_id") val deviceID: String,
)

@Serializable
data class UpdateBusinessConfigRequest(
    @SerialName("_id") val id: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("business_id") val BusinessID: String,
    @SerialName("currency") var currency: Currency? = null,
)